import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from '../admin.service';
import { TableComponent } from 'src/app/shared/common-components/table/table.component';
import { vovSharedService } from 'src/app/shared/services/vov-shared.service';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';




@Component({
  selector: 'app-reason-violation',
  templateUrl: './reason-violation.component.html',
  styleUrls: ['./reason-violation.component.scss']
})
export class ReasonViolationComponent implements OnInit {
  @ViewChild('formRef') formRef: TemplateRef<any>;
  @ViewChild('confirmRef') confirmRef: TemplateRef<any>;
  @ViewChild('changeInx') changeInx: TemplateRef<any>;


  @ViewChild(TableComponent, { static: false }) tableComp: TableComponent;
  public formDialog: MatDialogRef<any> = null;
  public confirmDialog: MatDialogRef<any> = null;
  public changeIndexDialog: MatDialogRef<any> = null;

  public tableData;
  public showSpinner: boolean = false;
  public columnNames = {
    index: 'Sequence',
    action: 'Actions',
    updatedAt: 'Date Added',
    actions: '',
  };
  selectedItem;
  reasonForm: FormGroup;
  changeIndex: FormGroup;
  previousIndexVal;

  constructor(public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    private vovSharedService: vovSharedService,
    public snackBar: MatSnackBar) { }


  ngOnInit(): void {
    this.reasonForm = this.formBuilder.group({
      action: ['', [Validators.required, this.vovSharedService.customFieldValidator, Validators.pattern(/^(?=.*\S).+$/)]],
      index: ['', [Validators.required, Validators.pattern(/^(?=.*\S).+$/)]]
    });

    this.changeIndex = this.formBuilder.group({
      fromIndex: ['', [Validators.required, Validators.pattern(/^(?=.*\S).+$/)]],
      toIndex: ['', [Validators.required, Validators.pattern(/^(?=.*\S).+$/)]]
    });
    this.getReasons();
  }

  getReasons() {
    this.showSpinner = true;
    this.vovSharedService.fetchAllViolationActions().subscribe(res => {
      console.log(res);
      this.showSpinner = false;
      if (res.actions.length > 0) {
        const UpdatedArr = res.actions.map((date: any) => date.updatedAt ? { ...date, updatedAt: moment(date.updatedAt).format("Do MMM YY") } : date);
        this.tableData = UpdatedArr;
      }
      this.tableRendering();
      console.log(this.tableData, 'dataa')
    })
  }

  openDialogForm() {
    this.formDialog = this.dialog.open(this.formRef, {
      width: '350px',
      data: 'data'
    });
    this.reasonForm.controls["index"].clearValidators();
    this.reasonForm.controls["index"].updateValueAndValidity();
    this.formDialog.afterClosed().subscribe(result => {
      this.selectedItem = '';
      this.reasonForm.reset();
    })
  }

  openDialogChnageIndex() {
    console.log(this.selectedItem, 'submitt')
    this.changeIndexDialog = this.dialog.open(this.changeInx, {
      width: '350px',
      data: 'data'
    });
    this.changeIndexDialog.afterClosed().subscribe(result => {
      this.selectedItem = '';
      this.changeIndex.reset();
    })
  }

  onReasonSubmit() {
    this.adminService.createViolationAction(this.reasonForm.value).subscribe((res) => {
      if (res.Action == 'Already Exist') {
        this.snackBar.open('' + 'Action already exist.', '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
      }
      this.getReasons();
      this.formDialog.close();
      this.reasonForm.reset();
    });
  }

  onIndexChanges() {
    const changedArray = this.array_move(this.tableData, this.changeIndex.value['fromIndex'], this.changeIndex.value['toIndex']);
    console.log(changedArray, 'changedArray')
    this.tableData = changedArray.filter(elem => elem);
    console.log(this.tableData, 'tabledataa')
    this.changeIndexDialog.close();
    this.tableRendering();
  }

  array_move(arr, old_index, new_index) {
    let old_in = +old_index - 1;
    let new_in = +new_index - 1;
    console.log(old_in, '*******', new_in)
    if (new_in >= arr.length) {
      var k = new_in - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_in, 0, arr.splice(old_in, 1)[0]);
    return arr; // for testing
  };

  selectedItems(item) {
    this.selectedItem = item.data;
    if (item.action === 'edit') {
      this.reasonForm.patchValue({
        action: item.data.action,
        index: item.data.index
      });
      this.openDialogForm();
    } else {
      this.confirmDialog = this.dialog.open(this.confirmRef, {
        width: '350px',
        data: 'data'
      });
    }
  }

  confirmDelete() {
    this.deleteReasons(this.selectedItem.id)
    this.confirmDialog.close();
    this.selectedItem = '';
    this.showSpinner = true;
    this.getReasons();

  }

  onNoClick() {
    this.confirmDialog.close();
  }

  editReason(e) {
    e.preventDefault();
    this.showSpinner = true;
    const oldIndex = this.tableData.find(res => res.id == this.selectedItem.id);
    this.adminService.updateViolationAction({ data: this.reasonForm.value, id: this.selectedItem.id }).subscribe((res) => {
      this.tableData = this.tableData.sort((a, b) => a.index - b.index);
      const changedArray = this.array_move(this.tableData, oldIndex.index, this.reasonForm.value['index']);
      let tableData = changedArray.filter(elem => elem);
      tableData = tableData.map((elm, i) => elm ? { ...elm, index: i + 1 } : null);
      this.adminService.updateIndexs(tableData).subscribe(res => {
        this.formDialog.close();
        setTimeout(() => {
          this.vovSharedService.fetchAllViolationActions().subscribe(res => {
            if (res.actions.length > 0) {
              this.reasonForm.reset();
              this.selectedItem = '';
              console.log(res.actions, 'res.actions')
              const UpdatedArr = res.actions.map((date: any) => date.updatedAt ? { ...date, updatedAt: moment(date.updatedAt).format("Do MMM YY") } : date);
              console.log(UpdatedArr, 'updated arrr')
              this.tableData = UpdatedArr.sort((a, b) => a.index - b.index);
              this.showSpinner = false;
              this.tableRendering();
            }
          });
        }, 1000);
        //this.tableRendering();

      });
    })
  }

  deleteReasons(reason) {
    this.adminService.deleteViolationAction(reason).subscribe((ress) => {
      this.vovSharedService.fetchAllViolationActions().subscribe(res => {
        this.snackBar.open('Success :' + ress.reason, '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'success-snackbar'
        });
        if (res.actions.length > 0) {
          const UpdatedArr = res.actions.map((date: any) => date.updatedAt ? { ...date, updatedAt: moment(date.updatedAt).format("Do MMM YY") } : date);
          this.tableData = UpdatedArr.map((elm, i) => elm ? { ...elm, index: i + 1 } : null);
          this.adminService.updateIndexs(this.tableData).subscribe(res => {
            this.showSpinner = false;
            this.tableRendering();
          })
        }
      })
    });
  }

  tableRendering() {
    if (this.tableComp != undefined) {
      this.tableComp.renderTable();
    }
  }


}
